<tds-header>
  <tds-header-hamburger
    (click)="mobileMenuAction()"
    aria-expanded="false"
    aria-haspopup="true"
  ></tds-header-hamburger>

  <tds-header-title>REALTIME KD</tds-header-title>

  <tds-header-dropdown slot="end" dropdown-icon>
    <div slot="icon">{{ selectedMarketLabel }}</div>

    <tds-header-dropdown-list size="lg">
      @for (market of userMarkets; track market) {
        <tds-header-dropdown-list-item
          >
          <a (click)="onChangeMarket(market.id)">
            <div class="tds-u-pl1">{{ market.name }}</div>
          </a>
        </tds-header-dropdown-list-item>
      }
    </tds-header-dropdown-list>
  </tds-header-dropdown>

  <tds-header-dropdown slot="end" class="profile" no-dropdown-icon>
    <tds-icon slot="icon" name="profile" size="24px"></tds-icon>

    <tds-header-dropdown-list size="lg">
      <tds-header-dropdown-list-user
        header="{{ username }}"
        subheader="{{ useremail }}"
      ></tds-header-dropdown-list-user>

      <tds-header-dropdown-list-item>
        <div class="app-version"><strong>App version:</strong> {{ appVersion }}</div>
        <div class="app-version"><strong>Angular version:</strong> {{ angularVersion }}</div>
      </tds-header-dropdown-list-item>

      <tds-header-dropdown-list-item>
        <a (click)="logout()">
          <tds-icon name="exit"></tds-icon>
          <div class="tds-u-pl1">Logout</div>
        </a>
      </tds-header-dropdown-list-item>
    </tds-header-dropdown-list>
  </tds-header-dropdown>
</tds-header>